import { StorageService } from './../../../common/services/storage.service';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';

import { NotificationService } from '../../../common/services/notification.service';
import { CurrentUser } from '../../../common/models/user';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { MatCardModule } from '@angular/material/card';
import { Association } from '../../../common/models/association';
import { AssociationService } from '../../../common/services/association.service';
import { Subject, takeUntil } from 'rxjs';
import { Guid } from 'guid-typescript';
import { FileUploadComponent } from '../../../common/components/file/file.component';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    imports: [
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    FileUploadComponent
]
})
export class NotificationComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  
  notificationForm: FormGroup;
  isEditMode = false;
  user: CurrentUser | null = null;
  notificationId: string | null = null;
  associations: Association[] = [];
  deliveryChannels = [
    { id: '4201e1b1-a58f-428b-8c8c-69f983a59c25', name: 'Email' },
    { id: '53e70041-81c1-4df3-844e-9d1ccc82715b', name: 'U aplikaciji' }
  ];

  isToggled = false;

  constructor(
    public themeService: CustomizerSettingsService,
    private fb: FormBuilder,
    private notificationService: NotificationService,
    private associationService: AssociationService,
    private storageService: StorageService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
    this.themeService.isToggled$.pipe(takeUntil(this.destroy$)).subscribe(isToggled => {
      this.isToggled = isToggled;
    });

    this.notificationForm = this.fb.group({
      title: ['', Validators.required],
      message: ['', Validators.required],
      associationIds: [[], Validators.required],
      deliveryChannelIds: [[], Validators.required],
      fileStorageLocation: [`notificationstorage/${Guid.create().toString()}`]
    });
  }

  ngOnInit(): void {
    this.storageService.user$.pipe(takeUntil(this.destroy$)).subscribe(user => {
      this.user = user;
      this.associationService.getAssociations(user?.municipalityId!).pipe(takeUntil(this.destroy$)).subscribe({
        next: (associations) => {
          this.associations = associations;
        },
        error: (error) => {
          console.error('Error fetching associations', error);
        }
      });

    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSubmit() {
    if (this.notificationForm.valid) {
        this.createNotification();
    }
  }

  createNotification() {
    if (this.user) {
      const createNotificationDto = {
        ...this.notificationForm.value,
        createdById: this.user.id
      };

      this.notificationService.createNotification(createNotificationDto).pipe(takeUntil(this.destroy$)).subscribe({
        next: () => {
          this.snackBar.open('Uspješno kreirana obavijest.', 'Zatvori', {
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'top'
          });
          this.router.navigate(['/municipality/notifications']);
        },
        error: () => {
          this.snackBar.open('Greška prilikom kreiranja obavijesti. Pokušajte ponovno.', 'Zatvori', {
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'top'
          });
        }
      });
    }
  }
}
